export default "__VITE_ASSET__BfDlSlvG__"